import postRequest from '../../postRequest';

/**
 * @param {string} deploymentMode "yes/No"
 * @param {date} fromDateTime
 * @param {date} toDateTime
 * @param {string} releaseNotes
 * @param {date} createdDate
 * @param {string} createdBy
 * @returns {object}
 */
const postDeployementDetails = (body) => {
  const endpoint = '/deployment/settings';
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Deployement details')
        .then((response) => resolve(response))
        .catch((error) => reject(error));
  });
};

export default postDeployementDetails;
